var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    _vm._l(_vm.modals, function(modal, index) {
      return _c(modal.acf.type, {
        key: index,
        tag: "component",
        attrs: {
          "modal-id": modal.acf.popup_id,
          data: modal.acf.data,
          showOnPageLoad: modal.acf.show_on_page_load,
          includePages: modal.acf.include_pages,
          excludePages: modal.acf.exclude_pages
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }